import React, { useState, useEffect, forwardRef } from   'react';
import { useParams, useNavigate} from 'react-router-dom';
import MenuEnlacesDX from './Componentes/MenuEnlacesDX';
import HeaderDXReloj from './Componentes/HeaderDXReloj';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import { useAuth } from '../../Auth/AuthContext';
import apiService from './../../Auth/apiService';
import { useForm, Controller } from 'react-hook-form';
import { FaCalendar } from 'react-icons/fa';
import moment from 'moment';
import { getMunicipiosDX, saveMunicipiosDX } from '../Utils/indexedDBUtils';

export default function DXDerechos() {
    const { iddx } = useParams();
    const { idrecepcion } = useParams();
    const { token, user } = useAuth();
    const Navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({})
    const [Cargando, setCargando] = useState(false)
    const [estadoDx, setEstadoDx] = useState('');
    const [municipios, setMunicipios] = useState([]);
    const [departamentosSisben, setDepartamentosSisben] = useState([]);
    const [municipiosSisben, setMunicipiosSisben] = useState([]);
    const [regimenfosyga, setRegimenfosyga] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    const [relacionpersonas, setRelacionpersonas] = useState([]);
    const [nivelesestudios, setNivelesestudios] = useState([]);
    const [cualesPersonasPsicoSeleccionadas , setCualesPersonasPsicoSeleccionadas] = useState([]);
    const [cualesPersonaJuridicaSeleccionadas , setCualesPersonaJuridicaSeleccionadas] = useState([]);
    const [fechaInicioAtencion, setFechaInicioAtencion] = useState(null);
    const { watch, handleSubmit, register, setValue, reset, control, formState: { errors }} = useForm({ 
            defaultValues: {
                iddx: '',
            } 
        }
    );
    const ActualizarPersonasPsico  = persona => {
        setCualesPersonasPsicoSeleccionadas(persona);
    };
    const ActualizarPersonaJuridica = persona => {
        setCualesPersonaJuridicaSeleccionadas(persona);
    };
    const Mensaje = (title, text, icon) => {
        setSwalProps({
            show: true,
            title,
            text,
            icon, // 'success' or 'error'
        });
    };
    function irAResultado(){
        if (estadoDx >= 7)
        Navigate(`/dx/resultado/${iddx}/${idrecepcion}`);
    }
    const InicializarFormulario = async () => {
        const url = '/diagnostico/crearformularioderechos';
        const obj = { iddx: iddx };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setFechaInicioAtencion(result.recepcion.repFechahoraatencion || null);
            setEstadoDx(result.estadodx);
            if(result.relacionpersonas){
                setRelacionpersonas(result.relacionpersonas);
            }else{
                Mensaje('Error', result.data.message, 'error');
            }
            if(result.regimenfosyga){
                setRegimenfosyga(result.regimenfosyga);
            }else{
                Mensaje('Error', result.data.message, 'error');
            }
            if(result.nivelesestudios){
                setNivelesestudios(result.nivelesestudios);
            }else{
                Mensaje('Error', result.data.message, 'error');
            }
            if(result.integrantes){
                const personas = result.integrantes.map((integrante) => ({value: integrante.id, label: `${integrante.nombre}`}));
                setIntegrantes(personas);
                if (result.derechos) {
                    FormReset(result.derechos, personas);
                }
            }else{
                Mensaje('Error', result.data.message, 'error');
            }
            if (!result.derechos) {
                Mensaje('Error', result.data.message, 'error');
            } else if (!result.integrantes) {
                FormReset(result.derechos);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    
    const FormReset = (data, integrantesData = integrantes) => {
        if (data?.der_5_6_1_2_departamento) {
            const nuevosMunicipiosSisben = municipios
                .filter((municipio) => municipio.mun_departamentoid === data.der_5_6_1_2_departamento.toString())
                .map((municipio) => ({ id: municipio.id, name: municipio.mun_municipio }))
            setMunicipiosSisben(nuevosMunicipiosSisben);
            setTimeout(() => {
                setValue('der_5_6_1_3_municipio', data.der_5_6_1_3_municipio?.toString() || '');
            }, 0);
        } else {
            setMunicipiosSisben([]);
            setValue('der_5_6_1_3_municipio', '');
        }
        if (data?.der_5_9_2_quien) {
            const psico = new Set(
                data.der_5_9_2_quien
                .split(',')
                .map((id) => id?.toString().trim())
                .filter(Boolean)
            );
            let cualesSeleccionadas = [];
            if (integrantesData && integrantesData.length > 0) {
                cualesSeleccionadas = integrantesData.filter((hecho) =>
                    psico.has(hecho.value?.toString().trim())
                );
            }
            setCualesPersonasPsicoSeleccionadas(cualesSeleccionadas);
        }
        if (data?.der_5_10_2_quien) {
            const jurid = new Set(
                data.der_5_10_2_quien
                .split(',')
                .map((id) => id?.toString().trim())
                .filter(Boolean)
            );
            let cualesSeleccionadas = [];
            if (integrantesData && integrantesData.length > 0) {
                cualesSeleccionadas = integrantesData.filter((hecho) =>
                    jurid.has(hecho.value?.toString().trim())
                );
            }
            setCualesPersonaJuridicaSeleccionadas(cualesSeleccionadas);
        }
        reset((prevValues) => ({
            ...prevValues,
            iddx: data?.iddx || '',
            der_5_1_1_integrante_sin_documento_identidad: data?.der_5_1_1_integrante_sin_documento_identidad || false,
            der_5_1_2_quien: data?.der_5_1_2_quien || '',
            der_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo: data?.der_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo || false,
            der_5_2_1_quien: data?.der_5_2_1_quien || '',
            der_5_2_2_condicion_integrante_que_reporta_riesgo: data?.der_5_2_2_condicion_integrante_que_reporta_riesgo || '',
            der_5_2_3_realizo_denuncio_referente_al_riesgo: data?.der_5_2_3_realizo_denuncio_referente_al_riesgo || '',
            der_5_3_1_donde_obtenian_ingresos_antes_del_hecho: data?.der_5_3_1_donde_obtenian_ingresos_antes_del_hecho || '',
            der_5_3_2_1_quien_era_generador_ingresos: data?.der_5_3_2_1_quien_era_generador_ingresos || '',
            der_5_3_2_cual_actividad: data?.der_5_3_2_cual_actividad || '',
            der_5_3_3_donde_provienen_ingresos_actualmente: data?.der_5_3_3_donde_provienen_ingresos_actualmente || '',
            der_5_3_4_cual_actividad: data?.der_5_3_4_cual_actividad || '',
            der_5_3_5_paga_arriendo: data?.der_5_3_5_paga_arriendo?.toString() || '',
            der_5_4_1_relacion_con_personas_donde_usted_esta: data?.der_5_4_1_relacion_con_personas_donde_usted_esta || '',
            der_5_5_1_casa_que_usted_abandono_era_propiedad: data?.der_5_5_1_casa_que_usted_abandono_era_propiedad || false,
            der_5_5_2_proteccion_juridica_propiedad: data?.der_5_5_2_proteccion_juridica_propiedad || '',
            der_5_5_3_hecho_intraurbano_dejo_bienes_abandonados: data?.vict_4_4_2_municipio === 12 ? data?.der_5_5_3_hecho_intraurbano_dejo_bienes_abandonados : '',
            der_5_6_1_1_tiene_sisben: data?.der_5_6_1_1_tiene_sisben || false,
            der_5_6_1_2_departamento: data?.der_5_6_1_2_departamento?.toString() || '',
            der_5_6_1_3_municipio: data?.der_5_6_1_3_municipio?.toString() || '',
            der_5_6_2_1_tiene_fosyga: data?.der_5_6_2_1_tiene_fosyga || false,
            der_5_6_2_2_regimen: data?.der_5_6_2_2_regimen || '',
            der_5_7_1_jefe_hogar_estudia_actualmente: data?.der_5_7_1_jefe_hogar_estudia_actualmente || false,
            der_5_7_2_nivel_de_estudio_jefe_hogar: data?.der_5_7_2_nivel_de_estudio_jefe_hogar || '',
            der_5_7_3_ultimo_grado_nivel_o_semestre_jefe_hogar: data?.der_5_7_3_ultimo_grado_nivel_o_semestre_jefe_hogar?.toString() || '',
            der_5_7_4_cuantos_nna_se_encuentran_desescolarizados: data?.der_5_7_4_cuantos_nna_se_encuentran_desescolarizados?.toString() || '',
            der_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif: data?.der_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif || false,
            der_5_8_2_quien: data?.der_5_8_2_quien || '',
            der_5_9_1_integrante_siente_afectacion_emocional_atencion_psic: data?.der_5_9_1_integrante_siente_afectacion_emocional_atencion_psic || false,
            der_5_9_2_quien: data?.der_5_9_2_quien || '',
            der_5_10_1_integrante_requiere_asesoria_juridica: data?.der_5_10_1_integrante_requiere_asesoria_juridica || false,
            vict_4_4_2_municipio: data?.vict_4_4_2_municipio || '',
            
        }));
    };  
    const onSubmit = async (data) => {
            setCargando(true);
            let url;
            url = '/diagnostico/guardarderechos';
            try {
                if (data) {
                    if (data.der_5_9_1_integrante_siente_afectacion_emocional_atencion_psic === true 
                        && cualesPersonasPsicoSeleccionadas.length === 0) {
                            Mensaje('Guardar', 'Debe seleccionar al menos una persona que requiera atención psicológica.', 'info');
                            return;
                        }
                    data.der_5_9_2_quien = cualesPersonasPsicoSeleccionadas.map(opt => opt.value).join(',');
                }
                if (data) {
                    if (data.der_5_10_1_integrante_requiere_asesoria_juridica === true 
                        && cualesPersonaJuridicaSeleccionadas.length === 0) {
                            Mensaje('Guardar', 'Debe seleccionar al menos una persona que requiera asesoría jurídica.', 'info');
                            return;
                        }
                    data.der_5_10_2_quien = cualesPersonaJuridicaSeleccionadas.map(opt => opt.value).join(',');
                }
                const response = await apiService.post(url, data, token);
                if(response.status === 200){
                    setEstadoDx(response.data.estadodx);
                    Mensaje('Guardar', JSON.stringify(response.data.message), 'success');
                }
            } catch (error) {
                if(error.status === 422){
                    Mensaje('Guardar', JSON.stringify(error.response.data.errors), 'error');
                }else if(error.status === 409){
                    Mensaje('Guardar', JSON.stringify(error.response.data), 'error');
                }else{
                    Mensaje('Guardar', `Error al guardar los datos: ${error}`, 'error');
                    console.error('Error fetching data:', error);
                }
            } finally {
                setCargando(false);
            }
        }; 
    async function fetchMunicipiosDX() {
        const url = '/diagnostico/obtenermunicipiosdx';
        return apiService.get(url, token)
            .then((response) => {
                if (Array.isArray(response.data.municipiosdx)) {
                    return response.data.municipiosdx;   
                }
                return null;
            })
            .catch((error) => {
                console.error('Error fetching municipios:', error);
                return null;
            });
    }
    async function getMunicipiosDXData() {
        const cachedmunicipiosDX = await getMunicipiosDX();
        if (cachedmunicipiosDX) {
            setMunicipios(cachedmunicipiosDX);
        } else {
            // If not in IndexedDB, fetch from the API
            const municipios = await fetchMunicipiosDX();
            if (municipios) {
                setMunicipios(municipios);
                await saveMunicipiosDX(municipios); // Save the result to IndexedDB
            }
        }
    }
    useEffect(() => {
        getMunicipiosDXData();
    }, []);
    useEffect(() => {
        if (municipios.length > 0) {
            setDepartamentosSisben([
                ...new Map(
                    municipios.map((municipio) => [
                        municipio.mun_departamentoid,
                        { id: municipio.mun_departamentoid, name: municipio.mun_departamento },
                    ])
                ).values(),
            ]);
        }
        InicializarFormulario();
    }, [municipios])
    return (
        
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Diagnostico base - Derechos"
                idCabezaFamilia="1"
                url="/dx/diagnosticodx"
                nombreurl="Diagnostico dx"
                nombreform="Derechos"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <HeaderDXReloj startTime={fechaInicioAtencion} estadoDx={estadoDx} />
                <MenuEnlacesDX iddx={iddx} idrecepcion={idrecepcion} buttonActive={6} estadoDx={estadoDx}/>

                <div id="formDiagnostico" className="card">
                    <div className="row">
                    <div className="col-md-12">
                        <div className="nav-tabs-custom">
                        <div className="tab-content">
                            <h4>5. ESTADO EN DERECHOS B&aacute;SICOS</h4>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card">
                                    <div className='card-body'>
                                            <div className="card-header">
                                        <h6 className="card-title"><b>5.1. Identificaci&oacute;n</b></h6>
                                        </div>
                                        <div className="row" >
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('der_5_1_1_integrante_sin_documento_identidad')}
                                                    onChange={(e) => {
                                                        setValue("der_5_1_1_integrante_sin_documento_identidad", e.target.checked)
                                                        if (!e.target.checked) {
                                                            setValue("der_5_1_2_quien", "")
                                                        }
                                                    }}
                                                    onMouseOver={() => { document.getElementById('infochkder_5_1_1__integrante_sin_documento_identidad').hidden = false; }}
                                                    onFocus={() => { document.getElementById('infochkder_5_1_1__integrante_sin_documento_identidad').hidden = false; }}
                                                    onMouseLeave={() => { document.getElementById('infochkder_5_1_1__integrante_sin_documento_identidad').hidden = true; }}
                                                    className="custom-control-input" id="der_5_1_1_integrante_sin_documento_identidad"
                                                    disabled/>
                                                <label className="custom-control-label" htmlFor="der_5_1_1_integrante_sin_documento_identidad"> 5.1.1. ¿Alg&uacute;n integrante del hogar esta sin documento de identidad?</label>
                                                <span hidden id="infochkder_5_1_1__integrante_sin_documento_identidad">Seleccione para Si</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_1_2_quien'>5.1.2. ¿Qui&eacute;n?</label>
                                            <input
                                                id="der_5_1_2_quien"
                                                type="text"
                                                className="form-control"
                                                placeholder="Ej. ANA PEREZ 18 AÑOS, CC."
                                                {...register('der_5_1_2_quien', {required: watch('der_5_1_1_integrante_sin_documento_identidad') ? "Este campo es obligatorio" : false })}
                                                onBlur={e => setValue('der_5_1_2_quien', e.target.value.toUpperCase())}
                                                onMouseOver={() => { document.getElementById('infotxtder_5_1_2__quien').hidden = false; }}
                                                onFocus={() => { document.getElementById('infotxtder_5_1_2__quien').hidden = false; }}
                                                onMouseLeave={() => { document.getElementById('infotxtder_5_1_2__quien').hidden = true; }}
                                                disabled
                                                
                                            />
                                            {errors.der_5_1_2_quien && <span className="text-danger">{errors.der_5_1_2_quien.message}</span>}
                                            <span hidden id="infotxtder_5_1_2__quien">Escriba a manera de observacion el nombre, edad y tipo de documento de la persona o personas a las que les falta el documento de identidad, previamente verificado en la constancia de declaracion.</span>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="card-header">
                                        <h6 className="card-title"><b>5.2. Vida</b></h6>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('der_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo')}
                                                        onChange={e => {
                                                            setValue('der_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo', e.target.checked)
                                                            if (!e.target.checked) {
                                                                setValue('der_5_2_1_quien', "")
                                                                setValue('der_5_2_2_condicion_integrante_que_reporta_riesgo', "")
                                                                setValue('der_5_2_3_realizo_denuncio_referente_al_riesgo', "")
                                                            }
                                                        }}
                                                        onMouseOver={() => { document.getElementById('infochkder_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo').hidden = false; }}
                                                        onFocus={() => { document.getElementById('infochkder_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo').hidden = false; }}
                                                        onMouseLeave={() => { document.getElementById('infochkder_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo').hidden = true; }}
                                                        className="custom-control-input"
                                                        id="der_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="der_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo">
                                                        5.2.1. ¿Alg&uacute;n integrante del Hogar, presenta alg&uacute;n riesgo extraordinario o extremo (amenaza fundada en hechos concretos, dirigida directamente a esa persona y que se est&eacute; dando ahora) que este poniendo en peligro su vida?
                                                    </label>
                                                    <span hidden id="infochkder_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo">
                                                        Seleccione para Si
                                                    </span>
                                                </div>
                                            </div>
                                        </div> 
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_2_1_quien'>5.2.1 ¿Qui&eacute;n?</label>
                                            <input
                                                id="der_5_2_1_quien"
                                                type="text"
                                                className="form-control"
                                                placeholder="Quien"
                                                {...register('der_5_2_1_quien', {required: watch('der_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo') ? "Este campo es obligatorio" : false })} 
                                                onBlur={e => setValue('der_5_2_1_quien', e.target.value.toUpperCase())}
                                                onMouseOver={() => { document.getElementById('infotxtder_5_2_1_quien').hidden = false; }}
                                                onFocus={() => { document.getElementById('infotxtder_5_2_1_quien').hidden = false; }}
                                                onMouseLeave={() => { document.getElementById('infotxtder_5_2_1_quien').hidden = true; }}
                                                disabled
                                                
                                            />
                                            {errors.der_5_2_1_quien && <span className="text-danger">{errors.der_5_2_1_quien.message}</span>}
                                            <span hidden id="infotxtder_5_2_1_quien">Nombre y parentesco con jefe de hogar.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_2_2_condicion_integrante_que_reporta_riesgo'>5.2.2. Condicion del integrante del Hogar que reporta el riesgo.</label>
                                            <input
                                                id="der_5_2_2_condicion_integrante_que_reporta_riesgo"
                                                type="text"
                                                className="form-control"
                                                placeholder="Condición"
                                                {...register('der_5_2_2_condicion_integrante_que_reporta_riesgo', {required: watch('der_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo') ? "Este campo es obligatorio" : false })}
                                                onBlur={e => setValue('der_5_2_2_condicion_integrante_que_reporta_riesgo', e.target.value.toUpperCase())}
                                                onMouseOver={() => { document.getElementById('infoslcder_5_2_2__Condicion_integrante_que_reporta_riesgo').hidden = false; }}
                                                onFocus={() => { document.getElementById('infoslcder_5_2_2__Condicion_integrante_que_reporta_riesgo').hidden = false; }}
                                                onMouseLeave={() => { document.getElementById('infoslcder_5_2_2__Condicion_integrante_que_reporta_riesgo').hidden = true; }}
                                                disabled
                                            />
                                            {errors.der_5_2_2_condicion_integrante_que_reporta_riesgo && <span className="text-danger">{errors.der_5_2_2_condicion_integrante_que_reporta_riesgo.message}</span>}
                                            <span hidden id="infoslcder_5_2_2__Condicion_integrante_que_reporta_riesgo">Indicar Cargo o Condicion de la Persona en Riesgo.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_2_3_realizo_denuncio_referente_al_riesgo'>5.2.3 Realiz&oacute; denuncio referente al Riesgo</label>
                                            <input
                                                id="der_5_2_3_realizo_denuncio_referente_al_riesgo"
                                                type="text"
                                                className="form-control"
                                                placeholder="Denuncio"
                                                {...register('der_5_2_3_realizo_denuncio_referente_al_riesgo', {required: watch('der_5_2_1_integrante_presenta_riesgo_extraordinario_o_extremo') ? "Este campo es obligatorio" : false })}
                                                onBlur={e => setValue('der_5_2_3_realizo_denuncio_referente_al_riesgo', e.target.value.toUpperCase())}
                                                disabled
                                            />
                                            {errors.der_5_2_3_realizo_denuncio_referente_al_riesgo && <span className="text-danger">{errors.der_5_2_3_realizo_denuncio_referente_al_riesgo.message}</span>}
                                            </div>
                                        </div>                 
                                        </div>
                                        <div className="card-header">
                                        <h6 className="card-title"><b>5.3. Generaci&oacute;n de Ingresos</b></h6>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_3_1_donde_obtenian_ingresos_antes_del_hecho'>5.3.1. ¿De d&oacute;nde obten&iacute;an los ingresos antes del hecho victimizante?</label>
                                            <input
                                                id="der_5_3_1_donde_obtenian_ingresos_antes_del_hecho"
                                                type="text"
                                                className="form-control"
                                                placeholder="Ingresos antes del hecho"
                                                {...register('der_5_3_1_donde_obtenian_ingresos_antes_del_hecho', { required: "Este campo es obligatorio" })}
                                                onBlur={e => setValue('der_5_3_1_donde_obtenian_ingresos_antes_del_hecho', e.target.value.toUpperCase())}
                                                disabled
                                            />
                                            {errors.der_5_3_1_donde_obtenian_ingresos_antes_del_hecho && <span className="text-danger">{errors.der_5_3_1_donde_obtenian_ingresos_antes_del_hecho.message}</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_3_2_cual_actividad'>5.3.2. ¿Cu&aacute;l actividad?</label>
                                            <input
                                                id="der_5_3_2_cual_actividad"
                                                type="text"
                                                className="form-control"
                                                placeholder="Cual"
                                                {...register('der_5_3_2_cual_actividad')}
                                                onBlur={e => setValue('der_5_3_2_cual_actividad', e.target.value.toUpperCase())}
                                                disabled
                                            />
                                            {errors.der_5_3_2_cual_actividad && <span className="text-danger">{errors.der_5_3_2_cual_actividad.message}</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_3_2_1_quien_era_generador_ingresos'>5.3.2.1 ¿Qui&eacute;n era el generador de estos Ingresos?</label>
                                            <input
                                                id="der_5_3_2_1_quien_era_generador_ingresos"
                                                type="text"
                                                className="form-control"
                                                placeholder="Quien"
                                                {...register('der_5_3_2_1_quien_era_generador_ingresos')}
                                                onBlur={e => setValue('der_5_3_2_1_quien_era_generador_ingresos', e.target.value.toUpperCase())}
                                                disabled
                                            />
                                            {errors.der_5_3_2_1_quien_era_generador_ingresos && (
                                                <span className="text-danger">{errors.der_5_3_2_1_quien_era_generador_ingresos.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_3_3_donde_provienen_ingresos_actualmente'>5.3.3. ¿De d&oacute;nde provienen los ingresos actualmente?</label>
                                            <input
                                                id="der_5_3_3_donde_provienen_ingresos_actualmente"
                                                type="text"
                                                className="form-control"
                                                placeholder="Ingresos actualmente"
                                                {...register('der_5_3_3_donde_provienen_ingresos_actualmente')}
                                                onBlur={e => setValue('der_5_3_3_donde_provienen_ingresos_actualmente', e.target.value.toUpperCase())}
                                                disabled
                                            />
                                            {errors.der_5_3_3_donde_provienen_ingresos_actualmente && (
                                                <span className="text-danger">{errors.der_5_3_3_donde_provienen_ingresos_actualmente.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_3_4_cual_actividad'>5.3.4. ¿Cu&aacute;l actividad?</label>
                                            <input
                                                id="der_5_3_4_cual_actividad"
                                                type="text"
                                                className="form-control"
                                                placeholder="Cual"
                                                {...register('der_5_3_4_cual_actividad')}
                                                onBlur={e => setValue('der_5_3_4_cual_actividad', e.target.value.toUpperCase())}
                                                disabled
                                            />
                                            {errors.der_5_3_4_cual_actividad && (
                                                <span className="text-danger">{errors.der_5_3_4_cual_actividad.message}</span>
                                            )}
                                            </div>
                                        </div>  
                                        <div className="col-md-12">
                                            <div className="form-group">  
                                                <label htmlFor="der_5_3_5_paga_arriendo">5.3.5. ¿Paga arriendo?</label>
                                                <select
                                                    id="der_5_3_5_paga_arriendo"
                                                    className="form-control"
                                                    {...register('der_5_3_5_paga_arriendo', { required: "Este campo es obligatorio" })}
                                                >
                                                    <option value="">Seleccione opci&oacute;n</option>
                                                    <option value="1">S&iacute;</option>
                                                    <option value="0">No</option>
                                                </select>
                                                {errors.der_5_3_5_paga_arriendo && (
                                                    <span className="text-danger">{errors.der_5_3_5_paga_arriendo.message}</span>
                                                )}
                                            </div>
                                        </div>                  
                                        </div>
                                        <div className="card-header">
                                        <h6 className="card-title"><b>5.4 Redes</b></h6>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_4_1_relacion_con_personas_donde_usted_esta'>5.4.1. ¿Qu&eacute; relaci&oacute;n tiene con las personas donde usted est&aacute; albergado?</label>
                                             <select
                                                className="form-control"
                                                id="der_5_4_1_relacion_con_personas_donde_usted_esta"
                                                {...register('der_5_4_1_relacion_con_personas_donde_usted_esta', { required: "Este campo es obligatorio" })}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {relacionpersonas.map(opt => (
                                                    <option key={opt.id} value={opt.id}>{opt.nombre}</option>
                                                ))}
                                            </select>
                                            {errors.der_5_4_1_relacion_con_personas_donde_usted_esta && (
                                                <span className="text-danger">{errors.der_5_4_1_relacion_con_personas_donde_usted_esta.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        </div>
                                        <div className="card-header">
                                        <h6 className="card-title"><b>5.5. Protecci&oacute;n de Bienes</b></h6>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="der_5_5_1_casa_que_usted_abandono_era_propiedad"
                                                        {...register('der_5_5_1_casa_que_usted_abandono_era_propiedad')}
                                                        onChange={e => {
                                                            setValue('der_5_5_1_casa_que_usted_abandono_era_propiedad', e.target.checked)
                                                            if (!e.target.checked) {
                                                                setValue('der_5_5_2_proteccion_juridica_propiedad', "")
                                                            }
                                                        }}
                                                        onMouseOver={() => { document.getElementById('infochkder_5_5_1_casa_que_usted_abandono_era_propiedad').hidden = false; }}
                                                        onFocus={() => { document.getElementById('infochkder_5_5_1_casa_que_usted_abandono_era_propiedad').hidden = false; }}
                                                        onMouseLeave={() => { document.getElementById('infochkder_5_5_1_casa_que_usted_abandono_era_propiedad').hidden = true; }}
                                                    />
                                                    <label className="custom-control-label" htmlFor="der_5_5_1_casa_que_usted_abandono_era_propiedad">
                                                        5.5.1. ¿La casa que usted abandon&oacute; era de su propiedad?
                                                    </label>
                                                    <span hidden id="infochkder_5_5_1_casa_que_usted_abandono_era_propiedad">Seleccione para Si.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_5_2_proteccion_juridica_propiedad'>5.5.2. Si la respuesta es afirmativa, realiz&oacute; protecci&oacute;n jur&iacute;dica ante ministerio publico?</label>
                                            <select
                                                className="form-control"
                                                id="der_5_5_2_proteccion_juridica_propiedad"
                                                {...register('der_5_5_2_proteccion_juridica_propiedad', { required: watch('der_5_5_1_casa_que_usted_abandono_era_propiedad') ? "Este campo es obligatorio" : false })}
                                                disabled={!watch('der_5_5_1_casa_que_usted_abandono_era_propiedad')}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                <option value="1">S&iacute;</option>
                                                <option value="2">No</option>
                                            </select>
                                            {errors.der_5_5_2_proteccion_juridica_propiedad && (
                                                <span className="text-danger">{errors.der_5_5_2_proteccion_juridica_propiedad.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_5_3_hecho_intraurbano_dejo_bienes_abandonados'>5.5.3. Si el desplazamiento fue intraurbano ¿dejo bienes y muebles abandonados?</label>
                                            <select
                                                className="form-control"
                                                id="der_5_5_3_hecho_intraurbano_dejo_bienes_abandonados"
                                                {...register('der_5_5_3_hecho_intraurbano_dejo_bienes_abandonados', { required: watch('vict_4_4_2_municipio') == 12 ? "Este campo es obligatorio" : false })}
                                                disabled={watch('vict_4_4_2_municipio') != 12}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                <option value="1">S&iacute;</option>
                                                <option value="2">No</option>
                                            </select>
                                            {errors.der_5_5_3_hecho_intraurbano_dejo_bienes_abandonados && (
                                                <span className="text-danger">{errors.der_5_5_3_hecho_intraurbano_dejo_bienes_abandonados.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        </div>
                                        <div className="card-header">
                                        <h6 className="card-title"><b>5.6. Salud</b></h6>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="der_5_6_1_1_tiene_sisben"
                                                        {...register('der_5_6_1_1_tiene_sisben')}
                                                        onChange={e => {
                                                            setValue('der_5_6_1_1_tiene_sisben', e.target.checked)
                                                            if (!e.target.checked) {
                                                                setValue('der_5_6_1_2_departamento', "")
                                                                setValue('der_5_6_1_3_municipio', "")
                                                            }
                                                        }}
                                                        onMouseOver={() => { document.getElementById('infochkder_5_6_1_1_tiene_sisben').hidden = false; }}
                                                        onFocus={() => { document.getElementById('infochkder_5_6_1_1_tiene_sisben').hidden = false; }}
                                                        onMouseLeave={() => { document.getElementById('infochkder_5_6_1_1_tiene_sisben').hidden = true; }}
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="der_5_6_1_1_tiene_sisben">
                                                        5.6.1.1. ¿Tiene SISBEN?
                                                    </label>
                                                    <span hidden id="infochkder_5_6_1_1_tiene_sisben">Seleccione para Si.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='der_5_6_1_2_departamento'>5.6.1.2 Departamento</label>
                                            <select
                                                className="form-control"
                                                id="der_5_6_1_2_departamento"
                                                {...register('der_5_6_1_2_departamento', { required: watch('der_5_6_1_1_tiene_sisben') ? "Este campo es obligatorio" : false })}
                                                onChange={e => {
                                                    setValue('der_5_6_1_2_departamento', e.target.value)
                                                    setValue('der_5_6_1_3_municipio', "")
                                                    if (e.target.value) {
                                                        setMunicipiosSisben(
                                                            municipios.filter((municipio) => municipio.mun_departamentoid === e.target.value)
                                                            .map((municipio) => ({ id: municipio.id, name: municipio.mun_municipio }))
                                                        );
                                                    }
                                                }}
                                                disabled
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {departamentosSisben.map(dep => (
                                                    <option key={dep.id} value={dep.id}>{dep.name}</option>
                                                ))}
                                            </select>
                                            {errors.der_5_6_1_2_departamento && (
                                                <span className="text-danger">{errors.der_5_6_1_2_departamento.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='der_5_6_1_3_municipio'>5.6.1.3. Municipio</label>
                                            <select
                                                className="form-control"
                                                id="der_5_6_1_3_municipio"
                                                {...register('der_5_6_1_3_municipio', { required: watch('der_5_6_1_1_tiene_sisben') ? "Este campo es obligatorio" : false })}
                                                onFocus={() => { document.getElementById('infoslcder_5_6_1_3__municipio').hidden = false; }}
                                                onBlur={() => { document.getElementById('infoslcder_5_6_1_3__municipio').hidden = true; }}
                                                disabled
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {municipiosSisben.map(mun => (
                                                    <option key={mun.id} value={mun.id}>{mun.name}</option>
                                                ))}
                                            </select>
                                            {errors.der_5_6_1_3_municipio && (
                                                <span className="text-danger">{errors.der_5_6_1_3_municipio.message}</span>
                                            )}
                                            <span hidden id="infoslcder_5_6_1_3__municipio">Selecciona el Municipio donde esta registrado el Sisben.</span>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="der_5_6_2_1_tiene_fosyga"
                                                        {...register('der_5_6_2_1_tiene_fosyga')}
                                                        onChange={e => {
                                                            setValue('der_5_6_2_1_tiene_fosyga', e.target.checked);
                                                            if (!e.target.checked) {
                                                                setValue('der_5_6_2_2_regimen', "");
                                                            }
                                                        }}
                                                        onMouseOver={() => { document.getElementById('infochkder_5_6_2_1_tiene_fosyga').hidden = false; }}
                                                        onFocus={() => { document.getElementById('infochkder_5_6_2_1_tiene_fosyga').hidden = false; }}
                                                        onMouseLeave={() => { document.getElementById('infochkder_5_6_2_1_tiene_fosyga').hidden = true; }}
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="der_5_6_2_1_tiene_fosyga">
                                                        5.6.2.1. ¿Tiene ADRES?
                                                    </label>
                                                    <span hidden id="infochkder_5_6_2_1_tiene_fosyga">Seleccione para Si.</span>
                                                </div>
                                            </div>
                                        </div> 
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_6_2_2_regimen'>5.6.2.2. R&eacute;gimen</label>
                                            <select
                                                className="form-control"
                                                id="der_5_6_2_2_regimen"
                                                {...register('der_5_6_2_2_regimen', { required: watch('der_5_6_2_1_tiene_fosyga') ? "Este campo es obligatorio" : false })}
                                                disabled
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {regimenfosyga.map(opt => (
                                                    <option key={opt.id} value={opt.id}>{opt.nombre}</option>
                                                ))}
                                            </select>
                                            {errors.der_5_6_2_2_regimen && (
                                                <span className="text-danger">{errors.der_5_6_2_2_regimen.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        </div>
                                        <div className="card-header">
                                        <h6 className="card-title"><b>5.7. Educaci&oacute;n</b></h6>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="der_5_7_1_jefe_hogar_estudia_actualmente"
                                                        {...register('der_5_7_1_jefe_hogar_estudia_actualmente')}
                                                        onChange={e => {
                                                            setValue('der_5_7_1_jefe_hogar_estudia_actualmente', e.target.checked)
                                                        }}
                                                        onMouseOver={() => { document.getElementById('infochkder_5_7_1_jefe_hogar_estudia_actualmente').hidden = false; }}
                                                        onFocus={() => { document.getElementById('infochkder_5_7_1_jefe_hogar_estudia_actualmente').hidden = false; }}
                                                        onMouseLeave={() => { document.getElementById('infochkder_5_7_1_jefe_hogar_estudia_actualmente').hidden = true; }}
                                                    />
                                                    <label className="custom-control-label" htmlFor="der_5_7_1_jefe_hogar_estudia_actualmente">
                                                        5.7.1 ¿El jefe de hogar estudia actualmente?
                                                    </label>
                                                    <span hidden id="infochkder_5_7_1_jefe_hogar_estudia_actualmente">Seleccione para Si.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='slcder_5_7_2_nivel_de_estudio_jefe_hogar'>5.7.2. Nivel de estudio hasta el cual curs&oacute; o en el cual se encuentra</label>
                                            <select
                                                className="form-control"
                                                id="slcder_5_7_2_nivel_de_estudio_jefe_hogar"
                                                {...register('der_5_7_2_nivel_de_estudio_jefe_hogar', { required: "Este campo es obligatorio" })}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {nivelesestudios.map(opt => (
                                                    <option key={opt.id} value={opt.id}>{opt.nombre}</option>
                                                ))}
                                            </select>
                                            {errors.der_5_7_2_nivel_de_estudio_jefe_hogar && (
                                                <span className="text-danger">{errors.der_5_7_2_nivel_de_estudio_jefe_hogar.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_7_3_ultimo_grado_nivel_o_semestre_jefe_hogar'>5.7.3 &uacute;ltimo grado, nivel o semestre de estudio aprobado</label>
                                            <select
                                                className="form-control"
                                                id="slcder_5_7_3_ultimo_grado_nivel_o_semestre_jefe_hogar"
                                                {...register('der_5_7_3_ultimo_grado_nivel_o_semestre_jefe_hogar', { required: "Este campo es obligatorio"})}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                <option value="0">Ninguno</option>
                                                <option value="1">Primero</option>
                                                <option value="2">Segundo</option>
                                                <option value="3">Tercero</option>
                                                <option value="4">Cuarto</option>
                                                <option value="5">Quinto</option>
                                                <option value="6">Sexto</option>
                                                <option value="7">Septimo</option>
                                                <option value="8">Octavo</option>
                                                <option value="9">Noveno</option>
                                                <option value="10">Decimo</option>
                                                <option value="11">Undecimo</option>
                                            </select>
                                            {errors.der_5_7_3_ultimo_grado_nivel_o_semestre_jefe_hogar && (
                                                <span className="text-danger">{errors.der_5_7_3_ultimo_grado_nivel_o_semestre_jefe_hogar.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_7_4_cuantos_nna_se_encuentran_desescolarizados'>5.7.4 ¿En el hogar cu&aacute;ntos Niños/Niñas/Adolecentes se encuentran desescolarizados?</label>
                                            <input
                                                id="der_5_7_4_cuantos_nna_se_encuentran_desescolarizados"
                                                type="number"
                                                className="form-control"
                                                placeholder="Cuantos"
                                                min="0"
                                                {...register('der_5_7_4_cuantos_nna_se_encuentran_desescolarizados', { 
                                                    required: "Este campo es obligatorio", 
                                                    min: { value: 0, message: "No puede ser negativo" },
                                                    pattern: { value: /^\d+$/, message: "Solo números" }
                                                })}
                                                onBlur={e => setValue('der_5_7_4_cuantos_nna_se_encuentran_desescolarizados', e.target.value)}
                                                onFocus={() => { document.getElementById('infotxtder_5_7_4_cuantos_nna_se_encuentran_desescolarizados').hidden = false; }}
                                                onMouseOver={() => { document.getElementById('infotxtder_5_7_4_cuantos_nna_se_encuentran_desescolarizados').hidden = false; }}
                                                onMouseLeave={() => { document.getElementById('infotxtder_5_7_4_cuantos_nna_se_encuentran_desescolarizados').hidden = true; }}
                                                disabled
                                            />
                                            {errors.der_5_7_4_cuantos_nna_se_encuentran_desescolarizados && (
                                                <span className="text-danger">{errors.der_5_7_4_cuantos_nna_se_encuentran_desescolarizados.message}</span>
                                            )}
                                            <span hidden id="infotxtder_5_7_4_cuantos_nna_se_encuentran_desescolarizados">Escriba el numero de Niños/Niñas/Adolescentes que se encuentran desescolarizados. (Si no hay escriba 0)</span>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="card-header">
                                        <h6 className="card-title"><b>5.8. Reunificaci&oacute;n Familiar</b></h6>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="der_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif"
                                                        {...register('der_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif')}
                                                        onChange={e => {
                                                            setValue('der_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif', e.target.checked);
                                                            if (!e.target.checked) {
                                                                setValue('der_5_8_2_quien', "");
                                                            }
                                                        }}
                                                        onMouseOver={() => { document.getElementById('infochkder_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif').hidden = false; }}
                                                        onFocus={() => { document.getElementById('infochkder_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif').hidden = false; }}
                                                        onMouseLeave={() => { document.getElementById('infochkder_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif').hidden = true; }}
                                                    />
                                                    <label className="custom-control-label" htmlFor="der_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif">
                                                        5.8.1. ¿Alg&uacute;n integrante del n&uacute;cleo familiar permanece en el lugar donde ocurri&oacute; el hecho victimizante y la familia requiere reunificaci&oacute;n?
                                                    </label>
                                                    <span hidden id="infochkder_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif">Seleccione para Si.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_8_2_quien'>5.8.2. ¿Qui&eacute;n?</label>
                                            <input
                                                id="der_5_8_2_quien"
                                                type="text"
                                                className="form-control"
                                                placeholder="Ej. Hija 5, Yerno 38."
                                                maxLength={1020}
                                                {...register('der_5_8_2_quien', {
                                                    required: watch('der_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif') ? "Este campo es obligatorio" : false
                                                })}
                                                onBlur={e => setValue('der_5_8_2_quien', e.target.value.toUpperCase())}
                                                onFocus={() => { document.getElementById('infotxtder_5_8_2__quien').hidden = false; }}
                                                onMouseOver={() => { document.getElementById('infotxtder_5_8_2__quien').hidden = false; }}
                                                onMouseLeave={() => { document.getElementById('infotxtder_5_8_2__quien').hidden = true; }}
                                                disabled={!watch('der_5_8_1_integrante_permanece_donde_ocurrio_el_hecho_reunif')}
                                            />
                                            {errors.der_5_8_2_quien && (
                                                <span className="text-danger">{errors.der_5_8_2_quien.message}</span>
                                            )}
                                            <span hidden id="infotxtder_5_8_2__quien">Escriba a manera de observacion el parentesco y la edad de la persona o personas de las que se requiere adelantar reunificacion familiar.</span>
                                            </div>
                                        </div> 
                                        </div>
                                        <div className="card-header">
                                        <h6 className="card-title"><b>5.9. Atenci&oacute;n Psicosocial</b></h6>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="der_5_9_1_integrante_siente_afectacion_emocional_atencion_psic"
                                                        {...register('der_5_9_1_integrante_siente_afectacion_emocional_atencion_psic')}
                                                        onChange={e => {
                                                            setValue('der_5_9_1_integrante_siente_afectacion_emocional_atencion_psic', e.target.checked);
                                                            if (!e.target.checked) {
                                                                setValue('der_5_9_2_quien', "");
                                                                setCualesPersonasPsicoSeleccionadas([]);
                                                            }
                                                        }}
                                                        onMouseOver={() => { document.getElementById('infochkder_5_9_1_integrante_siente_afectacion_emocional_atencion_psic').hidden = false; }}
                                                        onFocus={() => { document.getElementById('infochkder_5_9_1_integrante_siente_afectacion_emocional_atencion_psic').hidden = false; }}
                                                        onMouseLeave={() => { document.getElementById('infochkder_5_9_1_integrante_siente_afectacion_emocional_atencion_psic').hidden = true; }}
                                                    />
                                                    <label className="custom-control-label" htmlFor="der_5_9_1_integrante_siente_afectacion_emocional_atencion_psic">
                                                        5.9.1. ¿Alg&uacute;n integrante del n&uacute;cleo familiar presenta afectaci&oacute;n emocional, como consecuencia al hecho victimizante y desea recibir atenci&oacute;n psicol&oacute;gica?
                                                    </label>
                                                    <span id="infochkder_5_9_1_integrante_siente_afectacion_emocional_atencion_psic">Seleccione para Si.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="divHideQuienPsicosocial" className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_9_2_quien'>5.9.2. ¿Qui&eacute;n?</label>
                                            <Select
                                                id="der_5_9_2_quien"
                                                value={cualesPersonasPsicoSeleccionadas}
                                                isMulti
                                                name="der_5_9_2_quien"
                                                options={integrantes}
                                                onChange={ActualizarPersonasPsico}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                                isDisabled={!watch('der_5_9_1_integrante_siente_afectacion_emocional_atencion_psic')}
                                                styles={{
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999
                                                    })
                                                }}
                                            />
                                            {errors.der_5_9_2_quien && <p style={{ color: 'red' }}>Seleccione campos</p>}
                                            </div>
                                        </div>
                                        </div>
                                        <div className="card-header">
                                        <h6 className="card-title"><b>5.10. Atenci&oacute;n Jur&iacute;dica</b></h6>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="der_5_10_1_integrante_requiere_asesoria_juridica"
                                                        {...register('der_5_10_1_integrante_requiere_asesoria_juridica')}
                                                        onChange={e => {
                                                            setValue('der_5_10_1_integrante_requiere_asesoria_juridica', e.target.checked);
                                                            if (!e.target.checked) {
                                                                setValue('der_5_10_2_quien', "");
                                                                setCualesPersonaJuridicaSeleccionadas([]);
                                                            }
                                                        }}
                                                        onMouseOver={() => { document.getElementById('infochkder_5_10_1_integrante_requiere_asesoria_juridica').hidden = false; }}
                                                        onFocus={() => { document.getElementById('infochkder_5_10_1_integrante_requiere_asesoria_juridica').hidden = false; }}
                                                        onMouseLeave={() => { document.getElementById('infochkder_5_10_1_integrante_requiere_asesoria_juridica').hidden = true; }}
                                                    />
                                                    <label className="custom-control-label" htmlFor="der_5_10_1_integrante_requiere_asesoria_juridica">
                                                        5.10.1. ¿Alg&uacute;n integrante del hogar requiere asesor&iacute;a jur&iacute;dica por los hechos de los cuales fue victima?
                                                    </label>
                                                    <span hidden id="infochkder_5_10_1_integrante_requiere_asesoria_juridica">Seleccione para Si.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="divHideQuienJuridica" className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='der_5_10_2_quien'>5.10.2. ¿Qui&eacute;n?</label>
                                            <Select
                                                id="der_5_10_2_quien"
                                                value={cualesPersonaJuridicaSeleccionadas}
                                                isMulti
                                                name="der_5_10_2_quien"
                                                options={integrantes}
                                                onChange={ActualizarPersonaJuridica}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                                isDisabled={!watch('der_5_10_1_integrante_requiere_asesoria_juridica')}
                                                styles={{
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999
                                                    })
                                                }}
                                            />
                                            {errors.der_5_10_2_quien && <p style={{ color: 'red' }}>Seleccione campos</p>}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className='card-footer'>
                                        <div className="row">
                                            <div className="col-md-6">
                                            <button id="btnDxActualizarDerechos" type="submit" className="btn btn-block btn-primary btn-sm">Actualizar y seguir con Resultado
                                            </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </form>
                            
                        </div>
                        </div>
                    </div>
                    </div>
                </div>  
                <SweetAlert2
                    {...swalProps}
                    didClose={() => setSwalProps({})}
                    onConfirm={() => {
                        if (swalProps.icon === 'success') {
                            setSwalProps({});
                            irAResultado();
                        } else {
                            setSwalProps({});
                        }
                    }}
                />
                <Tooltip id="tooltiparriba" place="right"/>   
            </section>
        </div>
        
    )
  }